import(/* webpackChunkName: "widgets-module" */ 'Widgets/widgetSlickSlider');